import React from "react";
import { useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TabsCard from "../../../Components/Card/TabsCard";
import {EmailDeliveryLogContainer} from "./EmailDeliveryLogContainer";
import {EventLogContainer} from "./EventLogContainer";
import {SkynetLogContainer} from "./SkynetLogContainer";

function CustomerLoggingContainer({ }) {
    const {t} = useTranslation();
    const customer = useSelector(state => state.CustomerReducer.customer);
    
    return <TabsCard>
        {(!customer || customer.vbCustomer) && <TabsCard.Tab label={t("loggingContainer.skynetLog")}>
            <TabsCard.TabBody>
                <SkynetLogContainer customer={customer}/>
            </TabsCard.TabBody>
        </TabsCard.Tab>}
        {(!customer || !!customer.vossCustomer) && <TabsCard.Tab label={t("loggingContainer.eventLog")}>
            <TabsCard.TabBody>
                <EventLogContainer customer={customer}/>
            </TabsCard.TabBody>
        </TabsCard.Tab>}
        {(!customer || !!customer.vossCustomer) && <TabsCard.Tab label={t("loggingContainer.emailDeliveryLog")}>
            <TabsCard.TabBody>
                <EmailDeliveryLogContainer customer={customer}/>
            </TabsCard.TabBody>
        </TabsCard.Tab>}
    </TabsCard>
}

export default CustomerLoggingContainer;